import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import Modal from '../../modal';
import { DeleteAssignmentForm } from '../../forms';
import { Snackbar } from '../../snackbar';
import { getFullName } from '../../../utilities/string';
import { history } from './../../../configuration/store';

class DeleteAssignmentButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            job: undefined
        };

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onOpen() {
        const { job } = this.props;
        this.setState({ modal: true, job: { ...job } });
    }

    onClose() {
        this.setState({ modal: false, job: undefined });
    }

    onSubmit() {
        const { handleDelete, job } = this.props;

        handleDelete(job, () => {
            // this.onClose();
            history.go(-1);
            Snackbar.success(<FormattedMessage {...messages.assignmentDeleted} values={{ name: getFullName(job.user) }} />);
        });
    }

    render() {
        const { modal, job } = this.state;
        const { button } = this.props;

        let buttonComponent = button ? (
            button
        ) : (
            <span className="button danger" onClick={this.onOpen}>
                {' '}
                <FormattedMessage {...messages.delete} />
            </span>
        );

        return (
            <React.Fragment>
                {buttonComponent}
                <Modal
                    open={modal}
                    onClose={this.onClose}
                    managedClose
                    size="col-sm-8 col-sm-offset-2 col-xs-12 extend-modal"
                    title={<FormattedMessage {...messages.deleteAssignmentConfirmation} />}
                >
                    <DeleteAssignmentForm job={job} onSubmit={this.onSubmit} cancel={this.onClose} initialValues={job} />
                </Modal>
            </React.Fragment>
        );
    }
}

DeleteAssignmentButton.defaultProps = {
    button: undefined,
    onSuccess: () => {}
};
DeleteAssignmentButton.propTypes = {
    button: PropTypes.any,
    onSuccess: PropTypes.func
};
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(null, mapDispatchToProps)(DeleteAssignmentButton);



// WEBPACK FOOTER //
// ./src/components/richButtons/deleteAssignmentButton/index.jsx